/**
 * Data attribute used to identify the render root element.
 * This allows resource links to be placed outside the render boundary.
 */
export const SFS_RENDER_ROOT = "data-sfs-webpart-render-root";

/** Data attribute tracking the hydration lifecycle state of a webpart instance. */
export const SFS_HYDRATION_STATE = "data-sfs-webpart-hydration";

/** Data attribute identifying the form type (e.g. "classic" or "slider"). */
export const SFS_FORM_NAME = "data-sfs-webpart-form-name";

export type HydrationState = "none" | "pending" | "hydrated" | "error";
